import React from "react";
import Navbar from "../Components/Navbar";
import Footer from '../Components/Footer';
import JuniorCampPage1 from "../Components/JuniorCampPage1";
import JuniorCampPage2 from "../Components/JuniorCampPage2";
import JuniorCampPage3 from "../Components/JuniorCampPage3";
import '../Styles/CampsJuniors.scss';
import {Helmet} from "react-helmet";

function CampsJuniors() {
   return (
      <div>
         <Helmet>
            <title>Junior Overnight Camp - Camp Connect</title>
         </Helmet>
         <div className='juniorNavbar'>
            <Navbar />
         </div>
         <JuniorCampPage1 />
         <JuniorCampPage2 />
         <JuniorCampPage3 />
         <Footer/>
      </div>
   )
};

export default CampsJuniors;
